import styled from "styled-components";
import React from "react";
import Images from "../../assets/images/Images";
import classnames from "classnames";

interface InnerWrapperProps {
    backgroundImage: string
}
const SplashWrapper = styled.div`
    rankings-image-container {
        width: 100%
    }

    .animatedContainerBase {
        justify-content: center;
        gap: 1.25rem;
    }

    @media (min-width: 481px) {
        height: 100vh;
        max-height: 100vh;
        display: flex;
        flex: 1;
        background-image: url(${(props: InnerWrapperProps) => props.backgroundImage});
        background-repeat: repeat;
        justify-content: center;
        align-items: center;

        .r-image {
            height: 150px;
        }

        .rankings-image {
            width: 100%;
        }

        .animatedContainerBase {
            transition: all 1s ease-out;
            display: flex;
            flex-direction: column;
            margin-left: 20px
        }

        .hiddenSplashStyle {
            width: 0px;
            overflow: hidden;
        }

        .visibleSplashStyle {
            width: 360px;
            overflow: hidden;
        }
    }

    @media (max-width: 480px) {
        width: 100vw;
        max-width: 100vw;
        display: flex;
        flex: 1;
        background-image: url(${(props: InnerWrapperProps) => props.backgroundImage});
        background-repeat: repeat;

        justify-content: center;
        align-items: center;

        .r-image {
            height: 100px;
        }

        .rankings-image {
            width: 100%;
        }

        .animatedContainerBase {
            transition: all 1s ease-out;
            display: flex;
            flex-direction: column;
            margin-left: 20px;
        }

        .hiddenSplashStyle {
            width: 0px;
            overflow: hidden;
        }

        .visibleSplashStyle {
            width: 250px;
            overflow: hidden;
        }
    }
`;

const SplashContainer: React.FC<{show: boolean}> = ({ show }) => {
    return (
        <>
            <SplashWrapper
                className='InnerWrapp'
                backgroundImage={Images.backgroundTabs.Tab1}
            >
                <div style={{display: 'flex', flexDirection: 'row'}} >
                    <img
                      src={Images.r}
                      className={'r-image'}
                      alt='R'
                    />
                    <div className={classnames('animatedContainerBase', (show ? 'visibleSplashStyle' : 'hiddenSplashStyle'))}>
                        <div className="rankings-image-container">
                            <img
                              src={Images.rankingsTitle}
                              className={'rankings-image'}
                              alt='Rankings'
                            />
                        </div>
                        <div style={{fontSize: 12, whiteSpace: 'nowrap'}}>
                            <div>Development by</div>
                            <img
                              src={Images.logoWhiteBgEconomics}
                              style={{width: 120}}
                              alt='Mapfre Economics'
                            />
                        </div>
                    </div>
                </div>
            </SplashWrapper>
        </>
    )
};

export default SplashContainer;
